import {CampaignInstitution, CampaignPerson, Campaign} from '@shared/campaign';

// Generic Type to handle between campaign_institutions and campaign_people
export type CampaignTarget = (CampaignInstitution | CampaignPerson) & {
    entity_id: number;
    target_type: 'institution' | 'person';
};

/**
 * Normalizing Utility Function
 * @description
 * Can be used instead of directly accessing campaign.campaigns_institutions or campaign.campaigns_people
 * depending on the current parent module
 */
export function getCampaignTargets(campaign: Campaign, parentModule: 'institutions' | 'people'): CampaignTarget[] {
    if (parentModule === 'institutions') {
        return campaign.campaigns_institutions.map((ci: CampaignInstitution) => ({
            ...ci,
            entity_id: ci.institution_id,
            target_type: 'institution',
        }));
    } else {
        return campaign.campaigns_people.map((cp: CampaignPerson) => ({
            ...cp,
            entity_id: cp.person_id,
            target_type: 'person',
        }));
    }
}
